import { createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import {
  createGenericSlice,
  createReducers,
  ExtraReducers,
  GenericState,
} from 'stores/generics'
import { Payload } from 'stores'
import { ErrorStore, Question, Answer, QuizResponse } from '@types'
import {
  STORE_STATUS_INITIALIZED,
  STORE_QUIZ,
  STORE_QUIZ_FETCH_QUESTIONS,
} from 'constants/store'

export type QuizState = {
  answers: Answer[]
  timeout?: boolean
  current: number
  id?: string
  questions: Question[]
}

type State = GenericState<QuizState>

export const initialState: State = {
  data: {
    questions: [],
    answers: [],
    current: 0,
    id: undefined,
  },
  status: STORE_STATUS_INITIALIZED,
  error: null,
}

export const fetchQuestions = createAsyncThunk<
  QuizState,
  Promise<QuizResponse>,
  Payload
>(
  STORE_QUIZ_FETCH_QUESTIONS,
  async (promise: Promise<QuizResponse>, { rejectWithValue }) => {
    try {
      const response = await promise
      return {
        ...response,
        answers: [],
        current: 0,
      }
    } catch (e: unknown) {
      const { code, message } = e as ErrorStore
      return rejectWithValue({ code, message })
    }
  }
)

const extraReducers: ExtraReducers = createReducers<
  QuizState,
  QuizResponse,
  Payload
>(fetchQuestions, initialState.data)

const listSlice = createGenericSlice({
  name: STORE_QUIZ,
  initialState,
  reducers: {
    answerQuestion: (state, action: PayloadAction<Answer>) => {
      const answers: Answer[] = [...state.data.answers]
      const answer = action.payload

      answers[answer.order - 1] = answer

      return {
        ...state,
        data: {
          ...state.data,
          answers,
        },
      }
    },
    nextQuestion: (state) => {
      const sortedAnserws = JSON.parse(
        JSON.stringify([...state.data.answers])
      ).sort((a: Answer, b: Answer) => a.order - b.order)
      const lastAnswer = sortedAnserws[sortedAnserws.length - 1]

      return {
        ...state,
        data: {
          ...state.data,
          current: lastAnswer.order,
        },
      }
    },
  },
  extraReducers,
})

const { actions, reducer } = listSlice

const { clear, success, answerQuestion, nextQuestion } = actions

export { clear, success, answerQuestion, nextQuestion }

export default reducer
